import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import {
  Autocomplete,
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";

const ActualizarFinanciamientoModal = ({ open, onClose, folio }) => {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [facturas, setFacturas] = useState([]);
  const [relacion, setRelacion] = useState([]);
  const [selectedRegistro, setSelectedRegistro] = useState(null);
  const [editedData, setEditedData] = useState({});

  useEffect(() => {
    if (folio && open) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`DetalleFinanciamientoPedido/Detalle?folio=${folio}`)
        .then((result) => {
          setFacturas(result);
          // setArrayClientes(result);
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
        });
    }
  }, [folio]);

  useEffect(() => {
    if (folio && open) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`RelacionEQUIPHD/Relacion?folio=${folio}`)
        .then((result) => {
          setRelacion(result);
          // setArrayClientes(result);
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
        });
    }
  }, [folio]);

  const handleRowClick = (registro, orden) => {
    setSelectedRegistro(registro + "-" + orden);
  };

  const handleEditChange = (e, registro, orden) => {
    const { value } = e.target;

    setRelacion((prevRelacion) =>
      prevRelacion.map((rel) =>
        rel.registro === registro && rel.orden === orden
          ? { ...rel, docto_financiamiento: value }
          : rel
      )
    );
  };

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const onActualizar = async () => {
    setLoader({ ...loader, mostrar: true });

    try {
      for (const rel of relacion) {
        const post = {
          folio: folio,
          registro: rel.registro,
          orden: rel.orden,
          docto: rel.docto_financiamiento,
        };

        await request.post("RelacionEQUIPHD", post);
      }

      setLoader({ ...loader, mostrar: false });
      onClose();
      await Swal.fire({
        title: "ACTUALIZAR FINANCIAMIENTO",
        text: "Registros guardados con éxito",
        icon: "success",
        customClass: {
          container: "mi-superpoop",
        },
      });
    } catch (error) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("CLIENTES ESPECIALES", JSON.stringify(error), "error");
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div className="actualizar-financiamiento-modal-formulario">
          {/* <div className="actualizar-financiamiento-modal-plantilla">
            <div
              className="plantilla-screen-filtro-container"
              id="mdlFiltros-modal"
            > */}
          <PlantillaScreen
            titulo={"ACTUALIZAR FINANCIAMIENTO"}
            className_main={1}
            className={"plantilla-screen-filtro-container-modal"}
          >
            <div className="cerrar-modal-button" onClick={onClose}>
              X
            </div>
            <div className={`actualizar-financiamiento-modal-agregar-convenio`}>
              <div className="actualizar-financiamiento-modal-agregar-convenio-container scroll-4">
                <h3 className="titulo-seccion">
                  Detalle de Pedido Financiamiento
                </h3>
                <div className="facturas-screen">
                  <div className="facturas-container scroll-4">
                    <table cellSpacing={0} cellPadding={0}>
                      <thead>
                        <tr>
                          <th>Registro</th>
                          <th>
                            <div>Vencimiento</div>
                          </th>
                          <th>
                            <div>Importe a Financiar</div>
                          </th>
                          <th>
                            <div>Interes</div>
                          </th>
                          <th>
                            <div>Total a Pagar</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {facturas.map((fac) => (
                          <tr>
                            <td className="folio-celda">{fac.registro}</td>
                            <td className="documento-celda">
                              {fac.vencimiento}
                            </td>
                            <td className="saldo-celda">
                              {FormatMoney(fac.importefinanciar)}
                            </td>
                            <td className="saldo-celda">
                              {FormatMoney(fac.interes)}
                            </td>
                            <td className="saldo-celda">
                              {FormatMoney(fac.totalpagar)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <h3 className="titulo-seccion">
                  Relación de EQUIP con Humaya Digital
                </h3>
                <div className="relacion-screen">
                  <div className="relacion-container scroll-4">
                    <table cellSpacing={0} cellPadding={0}>
                      <thead>
                        <tr>
                          <th>Registro</th>
                          <th>
                            <div>Orden</div>
                          </th>
                          <th>
                            <div>Documento</div>
                          </th>
                          <th>
                            <div>Documento de Financiamiento</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {relacion.map((rel) => (
                          <tr
                            key={`${rel.registro}-${rel.orden}`}
                            onClick={() =>
                              handleRowClick(rel.registro, rel.orden)
                            }
                          >
                            <td className="folio-celda">{rel.registro}</td>
                            <td className="documento-celda">{rel.orden}</td>
                            <td className="documento-celda">{rel.documento}</td>
                            <td className="documento-celda">
                              {selectedRegistro ===
                              rel.registro + "-" + rel.orden ? (
                                <TextField
                                  value={rel.docto_financiamiento || ""}
                                  onChange={(e) =>
                                    handleEditChange(e, rel.registro, rel.orden)
                                  }
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                />
                              ) : (
                                rel.docto_financiamiento || "No registrado"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="actualizar-financiamiento-modal-buttons">
                <button
                  className="actualizar-financiamiento-modal-button-guardar"
                  onClick={() => onActualizar()}
                >
                  Guardar
                </button>
              </div>
            </div>
          </PlantillaScreen>
        </div>
        {/* </div>
        </div> */}
      </Modal>
    </>
  );
};

export default ActualizarFinanciamientoModal;
